import { NgModule, ModuleWithProviders, Injector, InjectionToken } from '@angular/core';
import { HttpModule, Http } from '@angular/http';

import { HttpInterceptorService, IHttpInterceptorConfig } from './interceptors/http-interceptor.service';
import { URLRegExpInterceptorMatcher } from './interceptors/url-regexp-interceptor-matcher.class';

export const /** @type {?} */ HTTP_CONFIG: InjectionToken<HttpConfig> = new InjectionToken<HttpConfig>('HTTP_CONFIG');

export type HttpConfig = {interceptors: IHttpInterceptorConfig[]};
/**
 * @param {?} http
 * @param {?} injector
 * @param {?} config
 * @return {?}
 */
export function httpFactory(http: Http, injector: Injector, config: HttpConfig): HttpInterceptorService {
  return new HttpInterceptorService(http, injector, new URLRegExpInterceptorMatcher(), config.interceptors);
}
export class QuiverHttpModule {
/**
 * @param {?=} config
 * @return {?}
 */
static forRoot(config: HttpConfig = {interceptors: []}): ModuleWithProviders {
    return {
      ngModule: QuiverHttpModule,
      providers: [{
          provide: HTTP_CONFIG,
          useValue: config,
        }, {
          provide: HttpInterceptorService,
          useFactory: httpFactory,
          deps: [Http, Injector, HTTP_CONFIG],
        },
      ],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpModule,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverHttpModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverHttpModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverHttpModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
